import { render, staticRenderFns } from "./WorkflowStepRenderer.vue?vue&type=template&id=04a4ac5b&scoped=true"
import script from "./WorkflowStepRenderer.vue?vue&type=script&lang=js"
export * from "./WorkflowStepRenderer.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStepRenderer.vue?vue&type=style&index=0&id=04a4ac5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a4ac5b",
  null
  
)

export default component.exports